import NumberFormat from 'react-number-format'
import styled from 'styled-components/macro'

export const DiceContainer = styled.div<{ isMobile?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
  width: ${({ isMobile }) => (isMobile ? '100%' : '80%')};
  margin: 0 auto;
`

export const SectionDice = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-top: 20px;
`

export const SectionText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin-top: 0px;
  width: 100%;
  max-width: 500px;
`
export const SectionRange = styled.div`
  display: flex;
  height: 50px;
  width: 80%;
  align-content: center;
  align-items: center;
  justify-content: center;
`
export const SectionRangeSlider = styled.div`
  -webkit-appearance: none;
  -moz-appearance: none;
  -webkit-slider-thumb;
  -moz-range-thumb;
  appearance: none;
  width: 100%;
  height: 10px;
  outline: none;
  border-radius: 3px;
  z-index: 1;
  background: red;
`

export const SectionRangeSelector = styled.div`
  width: calc(100% - 80px);
  left: 40px;
  height: 30px;
  z-index: 2;
  text-align: center;
  position: relative;
  color: white;
  font-weight: bold;
`
export const SectionRangeProgressBar = styled.div`
  width: 100%;
  height: 10px;
  background: #b5ff94;
  border-radius: 3px;
  top: -16px;
  position: relative;
  z-index: 1;
`
export const SectionRangeSliderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 30px);
  color: white;
  background: #0d0d0d;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 30px;
  box-shadow: 0 0 0.2rem #fff, 0 0 0.2rem #5bb389, 0 0 0.8rem #5bb389, 0 0 0.8rem #5bb389, 0 0 0.8rem #5bb389,
    inset 0 0 0.8rem #5bb389;
`

export const SectionRangeInputs = styled.div`
  width: 90%;
  height: 15px;
`
export const SectionRangeText = styled.div`
  text-align: center;
  margin-right: 10px;
  margin-left: 10px;
  width: 10px;
`
export const SectionRangeValue = styled.div`
  width: 35px;
  position: relative;
`

export const SectionConfiguration = styled.div`
  padding: 16px;
  width: 100%;
  border-radius: 20px;
  background: #0d0d0d;
  box-shadow: 0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #6aa251, 0 0 0.5rem #6aa251, 0 0 0.8rem #6aa251,
    inset 0 0 0.8rem #6aa251;
`

export const SectionInputBet = styled(NumberFormat)`
  background-color: transparent;
  width: 80%;
  text-align: center;
  color: #fff;
`

export const SectionInputAutoBet = styled.input<{ isMobile?: boolean }>`
  background-color: transparent;
  width: ${({ isMobile }) => (isMobile ? '80%' : '60%')};
  text-align: center;
  color: #fff;
`

export const SectionPlay = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
`

export const Dice = styled.div`
  width: 140px;
  height: 140px;
  border: 0.5rem double #ff4d4d;
  margin: 10px;
  border-radius: 15%;
  text-align: center;
  font-size: 5rem;
  text-vertical-align: middle;
`
export const DiceStyled = styled.div<{ under?: boolean; rolling: boolean }>`
  width: 140px;
  height: 140px;
  border: 0.5rem double #ff4d4d;
  margin: 10px;
  border-radius: 15%;
  text-align: center;
  font-size: 5rem;
  text-vertical-align: middle;
  border-color: ${({ under, rolling }) => (rolling ? '#5a5dff' : under ? '#e394ff' : '#b5ff94')};
  color: white;
  box-shadow: ${({ under, rolling }) =>
    rolling
      ? `0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #5a5dff, 0 0 0.5rem #5a5dff, 0 0 0.8rem #5a5dff,
  inset 0 0 0.8rem #5a5dff`
      : under
      ? `0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #bc13fe, 0 0 0.5rem #bc13fe, 0 0 0.8rem #bc13fe,
      inset 0 0 0.8rem #bc13fe`
      : `0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #6aa251, 0 0 0.5rem #6aa251, 0 0 0.8rem #6aa251,
      inset 0 0 0.8rem #6aa251`};
  text-shadow: ${({ under, rolling }) =>
    rolling
      ? `0 0 10px #fff, 0 0 1px #fff, 0 0 2px #fff, 0 0 4px #5a5dff, 0 0 8px #5a5dff, 0 0 9px #5a5dff,
      0 0 5px #5a5dff`
      : under
      ? `0 0 10px #fff, 0 0 1px #fff, 0 0 2px #fff, 0 0 4px #bc13fe, 0 0 8px #bc13fe, 0 0 9px #bc13fe,
      0 0 5px #bc13fe`
      : `0 0 10px #fff, 0 0 1px #fff, 0 0 2px #fff, 0 0 4px #6aa251, 0 0 8px #6aa251, 0 0 9px #6aa251,
      0 0 5px #6aa251`};
`
export const DiceStyledResult = styled.div<{ lose?: boolean }>`
  width: 50px;
  height: 50px;
  border: 0.5rem double #ff4d4d;
  border-radius: 15%;
  text-align: center;
  font-size: 1.5rem;
  border-color: ${({ lose }) => (lose ? '#5e2129' : '#b5ff94')};
  color: white;
  box-shadow: ${({ lose }) =>
    lose
      ? `0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #fd3e3e, 0 0 0.5rem #fd3e3e, 0 0 0.8rem #fd3e3e,
      inset 0 0 0.8rem #fd3e3e`
      : `0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #6aa251, 0 0 0.5rem #6aa251, 0 0 0.8rem #6aa251,
      inset 0 0 0.8rem #6aa251`};
  text-shadow: ${({ lose }) =>
    lose
      ? `0 0 10px #fff, 0 0 1px #fff, 0 0 2px #fff, 0 0 4px #fd3e3e, 0 0 8px #fd3e3e, 0 0 9px #fd3e3e,
      0 0 5px #fd3e3e`
      : `0 0 10px #fff, 0 0 1px #fff, 0 0 2px #fff, 0 0 4px #6aa251, 0 0 8px #6aa251, 0 0 9px #6aa251,
      0 0 5px #6aa251`};
`
export const DiceStyledBet = styled.div`
  width: 50px;
  height: 50px;
  border: 0.5rem double #ff4d4d;
  border-radius: 15%;
  text-align: center;
  font-size: 1.5rem;
  border-color: #2172e5;
  color: white;
  box-shadow: 0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #5199ff, 0 0 0.5rem #5199ff, 0 0 0.8rem #5199ff,
    inset 0 0 0.8rem #5199ff;
  text-shadow: 0 0 10px #fff, 0 0 1px #fff, 0 0 2px #fff, 0 0 4px #5199ff, 0 0 8px #5199ff, 0 0 9px #5199ff,
    0 0 5px #5199ff;
`
export const DiceUnder = styled.div`
  width: 140px;
  height: 140px;
  border: 0.5rem double #ff4d4d;
  margin: 10px;
  border-radius: 15%;
  text-align: center;
  font-size: 5rem;
  text-vertical-align: middle;
  border-color: #e394ff;
  color: white;
  box-shadow: 0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #bc13fe, 0 0 0.5rem #bc13fe, 0 0 0.8rem #bc13fe,
    inset 0 0 0.8rem #bc13fe;
  text-shadow: 0 0 10px #fff, 0 0 1px #fff, 0 0 2px #fff, 0 0 4px #bc13fe, 0 0 8px #bc13fe, 0 0 9px #bc13fe,
    0 0 5px #bc13fe;
`

export const DiceOver = styled.div`
  width: 140px;
  height: 140px;
  border: 0.5rem double #ff4d4d;
  margin: 10px;
  border-radius: 15%;
  text-align: center;
  font-size: 5rem;
  text-vertical-align: middle;
  border-color: #b5ff94;
  color: white;
  box-shadow: 0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #6aa251, 0 0 0.5rem #6aa251, 0 0 0.8rem #6aa251,
    inset 0 0 0.8rem #6aa251;
  text-shadow: 0 0 10px #fff, 0 0 1px #fff, 0 0 2px #fff, 0 0 4px #6aa251, 0 0 8px #6aa251, 0 0 9px #6aa251,
    0 0 5px #6aa251;
`

export const DiceRolling = styled.div`
  width: 140px;
  height: 140px;
  border: 0.5rem double #ff4d4d;
  margin: 10px;
  border-radius: 15%;
  text-align: center;
  font-size: 5rem;
  text-vertical-align: middle;
  border-color: #5a5dff;
  color: white;
  box-shadow: 0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #5a5dff, 0 0 0.5rem #5a5dff, 0 0 0.8rem #5a5dff,
    inset 0 0 0.8rem #5a5dff;
  text-shadow: 0 0 10px #fff, 0 0 1px #fff, 0 0 2px #fff, 0 0 4px #5a5dff, 0 0 8px #5a5dff, 0 0 9px #5a5dff,
    0 0 5px #5a5dff;
`
